var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevOpsValidating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000244141,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#FFE3F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.052 42.4376C43.4693 41.2908 45.4245 39.3556 46.596 36.9501C47.7674 34.5446 48.0855 31.8121 47.4977 29.2019C46.91 26.5916 45.4515 24.2591 43.3621 22.5879C41.2727 20.9166 38.6768 20.0061 36.0012 20.0061C33.3256 20.0061 30.7297 20.9166 28.6403 22.5879C26.5509 24.2591 25.0924 26.5916 24.5046 29.2019C23.9169 31.8121 24.2349 34.5446 25.4064 36.9501C26.5779 39.3556 28.533 41.2908 30.9504 42.4376V46.9376H41.052V42.4376Z",
    stroke: "#D8378E",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0938 51.6252H39.9062",
    stroke: "#D8378E",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsValidating);
export default __webpack_public_path__ + "static/media/DevOps_Validating.dc705719db9fb986a1bf33e302dd3691.svg";
export { ForwardRef as ReactComponent };